export const musclesFiltered = (activeTab, musclesSelected) => {
  if (!musclesSelected) return;
  if (activeTab === "1") return musclesSelected.slice(0, 2);
  if (activeTab === "2") return musclesSelected.slice(0, 4);

  return musclesSelected;
};
